import { IndexedDbDocStore } from '@/doc-sync/indexeddb-doc-store';

import { parseStoredPattern, patternMetaFromRecord } from './stored-pattern';
import type { PatternMetaExtra, StoredPattern } from './stored-pattern';

/** Separate module from store-instance so the cross-store wipe helper
 *  (src/persistence/owned-caches.ts) can construct a pattern local store
 *  without importing the singleton — avoids an import cycle. */
export function createPatternLocalStore(): IndexedDbDocStore<StoredPattern, PatternMetaExtra> {
	return new IndexedDbDocStore({
		dbName: 'azabu-patterns',
		dbVersion: 1,
		parse: parseStoredPattern,
		metaFromRecord: patternMetaFromRecord,
	});
}
